<div class="offer-details-container">
    <nova-detail-toolbar
        *ngIf="offerData"
        [title]="title"
        [template]="buttonsTemplate"
        (onGoBack)="goBack()"></nova-detail-toolbar>
    <ng-template #buttonsTemplate>
        <ng-container>
            <div class="buttons-placement flex-row justify-end items-center">
                <div *ngIf="!editMode">
                    <ng-container>
                        <button
                            mat-stroked-button
                            *ngIf="offerStatus.Rescinded | arrayContains: offerData?.eligibleStatuses"
                            type="button"
                            color="secondary"
                            (click)="openRescindReasonDialog()"
                            [disabled]="isOperationProcessing"
                            data-qa-id="shared_rescind_offer_btn">
                            Rescind offer
                        </button>
                        <button
                            mat-stroked-button
                            *ngIf="offerData?.canReactivateOffer"
                            type="button"
                            color="secondary"
                            (click)="enableEditMode()"
                            data-qa-id="shared_reactivate_offer_btn">
                            Re-activate offer
                        </button>
                        <button
                            mat-stroked-button
                            *ngIf="
                                (offerStatus.VendorReview | arrayContains: offerData?.eligibleStatuses) &&
                                !offerData?.canReactivateOffer
                            "
                            [disabled]="disableShowButtons"
                            type="button"
                            color="secondary"
                            (click)="updateStatusShowVendor()"
                            data-qa-id="shared_show_vendor_btn">
                            Show to Vendor
                        </button>
                        <button
                            mat-stroked-button
                            *ngIf="offerStatus.RecruiterReview | arrayContains: offerData?.eligibleStatuses"
                            type="button"
                            color="secondary"
                            [disabled]="disableShowButtons"
                            (click)="updateStatusShowRecruiter()"
                            data-qa-id="shared_show_recruiter_btn">
                            Show to Recruiter
                        </button>
                        <button
                            mat-stroked-button
                            *ngIf="offerStatus.ContractRequested | arrayContains: offerData?.eligibleStatuses"
                            type="button"
                            color="secondary"
                            (click)="openContractRequestDialog(true)"
                            data-qa-id="shared_contract_request_offer_btn">
                            Contract Request Offer
                        </button>
                    </ng-container>
                </div>
                <div>
                    <ng-container>
                        <button
                            mat-stroked-button
                            *ngIf="editMode && (offerStatus.VendorReview | arrayContains: offerData?.eligibleStatuses)"
                            type="button"
                            [disabled]="detailsFormGroup.invalid"
                            class="save-vendor"
                            color="secondary"
                            (click)="updateOffer(true)"
                            data-qa-id="shared_save_show_vendor_btn">
                            Save + Show to vendor
                        </button>
                    </ng-container>
                    <button
                        mat-flat-button
                        *ngIf="!editMode && offerData?.canEdit && !offerData?.canReactivateOffer"
                        type="button"
                        class="mat-raised-button mat-primary"
                        color="primary"
                        (click)="enableEditMode()"
                        data-qa-id="shared_edit_offer_btn"
                        [disabled]="isOfferOptimizationsEnabled() && isLoading">
                        Edit
                    </button>
                    <button
                        mat-flat-button
                        *ngIf="showCreateContractRequestButton()"
                        type="button"
                        color="primary"
                        (click)="openMargin(offerData?.marginId)"
                        data-qa-id="shared_create_contract_req_offer_btn">
                        CREATE CONTRACT REQUEST
                    </button>
                    <ng-container>
                        <button
                            mat-stroked-button
                            color="secondary"
                            *ngIf="offerData?.readyForVerballyAccepted"
                            aria-label="Button to share offer as verbally accepted"
                            data-qa-id="verbally_accept_button"
                            [matTooltip]="
                                offerData?.offerVerballyAccepted
                                    ? 'This offer has been shared as verbally accepted'
                                    : 'Share that this offer has been verbally accepted'
                            "
                            [disabled]="offerData?.offerVerballyAccepted"
                            (click)="verballyAcceptOffer()">
                            {{ offerData.offerVerballyAccepted ? 'VERBALLY ACCEPTED' : 'VERBALLY ACCEPT' }}
                        </button>
                    </ng-container>
                    <button
                        mat-flat-button
                        *ngIf="!editMode && (offerStatus.Declined | arrayContains: offerData?.eligibleStatuses)"
                        type="button"
                        color="secondary"
                        (click)="declineOffer()"
                        data-qa-id="shared_decline_offer_btn">
                        Decline Offer
                    </button>
                    <button
                        mat-flat-button
                        *ngIf="editMode && offerData?.canEdit"
                        type="submit"
                        [disabled]="detailsFormGroup.invalid"
                        color="primary"
                        (click)="updateOffer()"
                        data-qa-id="shared_save_btn">
                        Save
                    </button>
                    <button
                        mat-flat-button
                        *ngIf="
                            editMode &&
                            detailsFormGroup.controls.isContractRequestStatus.value &&
                            offerData?.offerType === offerTypeEnum.Agency
                        "
                        type="button"
                        [disabled]="detailsFormGroup.invalid"
                        color="primary"
                        (click)="openContractRequestDialog(false)"
                        data-qa-id="SaveReqContractBtn">
                        Save + Request Contract
                    </button>
                    <button
                        mat-stroked-button
                        *ngIf="editMode && offerData?.canEdit"
                        type="button"
                        color="secondary"
                        (click)="enableViewMode()"
                        data-qa-id="CancelEditBtn"
                        >Cancel</button
                    >
                </div>
            </div>
        </ng-container>
    </ng-template>
    <ng-container>
        <nova-banner
            *ngIf="editMode && validateCandidateProfessionJobs"
            bannerType="alert"
            bannerMessage="Clinician's profession must match the job's profession. Please review and update before creating an Offer.">
        </nova-banner>
    </ng-container>
    <div
        class="progress flex-grow flex-row justify-center"
        *ngIf="isLoading">
        <mat-progress-spinner
            mode="indeterminate"
            diameter="96"></mat-progress-spinner>
    </div>
    <div class="offer-details-content"
    [class.hidden-content]="isOfferOptimizationsEnabled() && isLoading"
    [class.bg-grey]="isOfferOptimizationsEnabled()"
    [ngClass]="{'deal-details-layout': isDealDetailsLayout}">
        @if (isOfferOptimizationsEnabled()) {
            @if (editMode) {
                <div class="main-container"
                >
                    <div class="left-container bg-grey">
                        <form [formGroup]="detailsFormGroup">
                            <div class="details__banner mb-4">
                                <mat-icon
                                    aria-hidden="false"
                                    aria-label="Offer disclaimer"
                                    fontIcon="info"
                                    class="flex-none"></mat-icon>
                                <div class="details__banner-message">
                                    <span
                                        >Deal data is pre-populated from the current job details in the JobID linked to
                                        this offer and compared to the original job details when the candidate
                                        submitted.
                                    </span>
                                    <span>*RTO is captured from most recent Nova submittal snapshot.</span>
                                </div>
                            </div>

                            <mat-card class="details__info-card mb-4">
                                <mat-card-header>
                                    <mat-card-title>Important Details</mat-card-title>
                                </mat-card-header>
                                <mat-card-content>
                                    <div class="flex-col flex-1">
                                        <mat-form-field>
                                            <textarea
                                                matInput
                                                formControlName="otherDetails"
                                                class="other-notes-textarea"
                                                data-qa-id="OtherDetails">
                                            </textarea>
                                            <mat-hint align="end"
                                                >{{ detailsFormGroup.controls.otherDetails.value?.length }}/1500
                                                characters</mat-hint
                                            >
                                        </mat-form-field>
                                    </div>
                                </mat-card-content>
                            </mat-card>

                            <mat-card class="mb-4">
                                <mat-card-header class="mb-2">
                                    <mat-card-title>Internal Offer Details</mat-card-title>
                                </mat-card-header>
                                <mat-card-content>
                                    <div class="details">
                                        @if (offerData?.offerType !== offerTypeEnum.Direct) {
                                            <div class="details__item details__gap">
                                                <mat-label class="details__item--label">Vendor</mat-label>
                                                <span>{{ offerData?.vendorName }}</span>
                                            </div>
                                            <div class="details__item">
                                                <mat-label class="details__item--label">Vendor Contact</mat-label>
                                                <mat-form-field class="details__item--control">
                                                    <mat-select formControlName="vendorContactId">
                                                        @for (option of vendorLookups?.contacts; track option.id) {
                                                            <mat-option [value]="option.id">
                                                                {{ option.name }}
                                                            </mat-option>
                                                        }
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        }

                                        <div class="details__item details__gap">
                                            <mat-label class="details__item--label">Candidate</mat-label>
                                            <div class="flex-row">
                                                @if (urlParent && offerData?.candidateId) {
                                                    <a
                                                        class="nova__link"
                                                        target="_blank"
                                                        [routerLink]="[
                                                            '/recruiting/candidates',
                                                            offerData?.candidateId,
                                                            'new-profile'
                                                        ]"
                                                        rel="noopener"
                                                        >{{ offerData?.candidateName }}</a
                                                    >
                                                } @else {
                                                    {{ offerData?.candidateName }}
                                                }
                                                @if (offerData?.candidateEmail) {
                                                    <span class="ml-1">({{ offerData?.candidateEmail }})</span>
                                                }
                                            </div>
                                        </div>

                                        <div class="details__item">
                                            <mat-label class="details__item--label">Contract Type</mat-label>
                                            <mat-form-field class="details__item--control">
                                                <mat-select formControlName="contractTypeId">
                                                    @for (option of lookups?.contracts; track option.id) {
                                                        <mat-option [value]="option.id">
                                                            {{ option.code }}
                                                        </mat-option>
                                                    }
                                                </mat-select>
                                            </mat-form-field>
                                        </div>

                                        <div class="details__item details__gap">
                                            <mat-label class="details__item--label">Contract Status</mat-label>
                                            <span
                                                (click)="
                                                    goToContractRequest(
                                                        offerData?.contractRequestId,
                                                        offerData?.marginId
                                                    )
                                                "
                                                (keydown.enter)="
                                                    goToContractRequest(
                                                        offerData?.contractRequestId,
                                                        offerData?.marginId
                                                    )
                                                "
                                                class="nova__link">
                                                {{ offerData?.contractRequestStatus }}
                                            </span>
                                        </div>

                                        <div class="details__item">
                                            <mat-label class="details__item--label">Job ID</mat-label>
                                            <div class="diff-enabled">
                                                <mat-form-field class="details__item--control">
                                                    <input
                                                        type="number"
                                                        matInput
                                                        formControlName="jobId"
                                                        [matAutocomplete]="jobIdAuto"
                                                        (change)="jobIdSelection($event)" />
                                                    <mat-autocomplete
                                                        #jobIdAuto="matAutocomplete"
                                                        [displayWith]="displayJobIds"
                                                        (optionSelected)="jobIdSelection($event)">
                                                        @for (job of filteredJobIdOptions | async; track job) {
                                                            <mat-option [value]="job">{{ job }} </mat-option>
                                                        }
                                                    </mat-autocomplete>
                                                    @if (isDifferent('jobId')) {
                                                        <mat-hint class="diff-line"
                                                            >OFFER:
                                                            <span class="diff-value">
                                                                {{ snapshotData().jobDetails?.jobId }}
                                                            </span></mat-hint
                                                        >
                                                    }
                                                </mat-form-field>
                                            </div>
                                        </div>

                                        @if (offerData?.offerType === offerTypeEnum.Direct) {
                                            <div class="details__item details__gap">
                                                <mat-label class="details__item--label">Offer Margin</mat-label>
                                                <div class="flex-col gap-8 flex-1 margin-field-container">
                                                    @if (offerData?.marginId) {
                                                        <div>
                                                            <a
                                                                (click)="openMarginCalculator(offerData?.marginId)"
                                                                class="nova__link ng-star-inserted"
                                                            >
                                                                {{ offerData?.marginId }}
                                                            </a>
                                                            @if (offerData?.importedFromMarginId) {
                                                                &nbsp;(Margin created from
                                                                {{ offerData?.importedFromMarginId }} margin
                                                                {{ offerData?.marginImportDateUtc | date: 'MM/dd/yyyy - hh:mm a' }})
                                                            }
                                                        </div>
                                                    } @else {
                                                        {{ '0%' }}
                                                    }
                                                    @if (offerMarginDifferences && offerMarginDifferences.length) {
                                                        <div>
                                                            <span
                                                                (click)="openMarginDifferences()"
                                                                (keydown.enter)="openMarginDifferences()"
                                                                class="nova__link ng-star-inserted"
                                                            >
                                                                View Differences
                                                            </span>
                                                        </div>
                                                    }
                                                    @if (showSampleMarginButton() || showCreateAndImportMarginButtons() || showImportMarginButton()) {
                                                        <div class="flex-col gap-8 margin-buttons">
                                                            @if (showSampleMarginButton()) {
                                                                <button
                                                                    mat-flat-button
                                                                    data-qa-id="addSampleMargin"
                                                                    class="margin-btn"
                                                                    color="primary"
                                                                    (click)="duplicateSampleMargin()"
                                                                    [disabled]="disableSampleMargin()"
                                                                    [matTooltip]="sampleMarginTooltip()"
                                                                >
                                                                    ADD SAMPLE MARGIN
                                                                </button>
                                                            }
                                                            @if (showCreateAndImportMarginButtons()) {
                                                                <button
                                                                    mat-stroked-button
                                                                    color="secondary"
                                                                    (click)="showImportMarginDialog()"
                                                                >
                                                                    IMPORT MARGIN
                                                                </button>
                                                                <button
                                                                    mat-stroked-button
                                                                    color="secondary"
                                                                    (click)="createOfferMargin()"
                                                                >
                                                                    CREATE MARGIN
                                                                </button>
                                                            }
                                                            @if (showImportMarginButton()) {
                                                                <button
                                                                    mat-stroked-button
                                                                    class="margin-btn"
                                                                    color="secondary"
                                                                    (click)="showImportMarginDialog()"
                                                                >
                                                                    IMPORT MARGIN
                                                                </button>
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        }

                                        <div class="details__item">
                                            <mat-label class="details__item--label">Facility Rate</mat-label>
                                            <mat-form-field class="details__item--control">
                                                <input
                                                    type="number"
                                                    matInput
                                                    formControlName="facilityRate"
                                                    (keyup)="updateVendorRate()"
                                                    (keydown)="validateInput($event)"
                                                    (change)="calculateContractDates('facilityRateChanged')" />
                                                <span matTextPrefix>$</span>
                                                @if (isDifferent('facilityRate')) {
                                                    <mat-hint class="diff-line"
                                                        >OFFER:
                                                        <span class="diff-value">
                                                            ${{ snapshotData().jobDetails?.billRate }}
                                                        </span>
                                                    </mat-hint>
                                                }
                                            </mat-form-field>
                                        </div>

                                        @if (offerData?.offerType !== offerTypeEnum.Direct) {
                                            <div class="details__item details__gap">
                                                <mat-label class="details__item--label">Vendor Rate</mat-label>
                                                @if (rateEnabled) {
                                                    <mat-form-field class="details__item--control">
                                                        <input
                                                            type="number"
                                                            matInput
                                                            formControlName="vendorRate"
                                                            (keydown)="validateInput($event)" />
                                                        <span matTextPrefix>$</span>
                                                    </mat-form-field>
                                                } @else {
                                                    <div class="flex-row items-center gap-4 details__item--control">
                                                        <span>{{ detailsFormGroup?.controls['vendorRate']?.value | currency }}</span>
                                                        <span
                                                            (click)="rateEdit()"
                                                            (keydown.enter)="rateEdit()"
                                                            (keydown.space)="rateEdit()"
                                                            tabindex="0"
                                                            role="button"
                                                            class="material-icons pencil"
                                                            >edit</span
                                                        >
                                                    </div>
                                                }
                                            </div>
                                        }

                                        @if (offerData?.offerType === offerTypeEnum.Direct) {
                                            <div class="details__item details__gap">
                                                <mat-label class="details__item--label">Target Margin</mat-label>
                                                <div class="flex-col">
                                                    <span>{{ offerData?.jobTargetMargin ?? 0 }}%</span>
                                                </div>
                                            </div>

                                            <div class="details__item">
                                                <mat-label class="details__item--label">Aya Paid Bonus</mat-label>
                                                <mat-form-field class="details__item--control">
                                                    <input
                                                        type="number"
                                                        matInput
                                                        formControlName="ayaPaidBonus"
                                                        (keydown)="validateInput($event)"
                                                        data-qa-id="ayaPaidBonusInput"
                                                        min="0"
                                                        max="999999.99"
                                                    />
                                                    <mat-error>Please enter valid bonus amount.</mat-error>
                                                    <span matTextPrefix>$</span>
                                                    @if (isDifferent('ayaPaidBonus')) {
                                                        <mat-hint class="diff-line">OFFER:
                                                            <span class="diff-value">${{ snapshotData().jobDetails?.ayaPaidBonus }}</span></mat-hint>
                                                    }
                                                </mat-form-field>
                                            </div>
                                        }
                                        @if (offerData?.recruiterBonus) {
                                            <div class="details__item">
                                                <mat-label class="details__item--label">Doughboy</mat-label>
                                                <div class="flex-row">
                                                    <span>{{ offerData?.recruiterBonus | currency }}</span>
                                                    <nova-recruiter-bonus
                                                        class="recruiter-bonus-icon"
                                                        [bonus]="offerData?.recruiterBonus">
                                                    </nova-recruiter-bonus>
                                                </div>
                                            </div>
                                        }

                                        @if (offerData?.isRemoteBooking !== null) {
                                            <div class="details__item details__gap items-center">
                                                <mat-label class="details__item--label">Work Model</mat-label>
                                                <mat-radio-group
                                                    formControlName="isRemoteBooking"
                                                    name="isRemoteBooking"
                                                    data-qa-id="job-details-work-model-radio">
                                                    <mat-radio-button
                                                        class="nml-6"
                                                        [value]="false"
                                                        >Onsite</mat-radio-button
                                                    >
                                                    <mat-radio-button
                                                        class="ml-3"
                                                        [value]="true"
                                                        >Remote</mat-radio-button
                                                    >
                                                </mat-radio-group>
                                            </div>
                                        }

                                        @if (offerData?.isPatientFacing !== null) {
                                            <div
                                                class="details__item details__gap"
                                                data-qa-id="job-details-work-type">
                                                <mat-label class="details__item--label">Work Type</mat-label>
                                                <span>{{
                                                    offerData?.isPatientFacing ? 'Patient-Facing' : 'Non-Patient-Facing'
                                                }}</span>
                                            </div>
                                        }

                                        @if (offerData?.offerType === offerTypeEnum.Direct) {
                                            <div class="details__item pipeline-request-instructions">
                                                <div class="flex-row">
                                                    <div class="pri-text">
                                                        <mat-label class="details__item--label ppl-label"
                                                            >Pipelines Request Instructions
                                                        </mat-label>
                                                    </div>
                                                    <div class="pri-icon">
                                                        <mat-icon
                                                            class="pipeline-request-instruction-info-icon"
                                                            matTooltip="Use this field to specify what should be added to the contract - such as special rate details (holiday, RTO, OT), end date rules, or unique shift information for the traveler's contract"
                                                            >info</mat-icon
                                                        >
                                                    </div>
                                                </div>
                                                <div class="flex-col flex-1">
                                                    <mat-form-field>
                                                        <textarea
                                                            matInput
                                                            class="textarea-control"
                                                            formControlName="pipelineRequestInstructions"
                                                            data-qa-id="PipelineRequestInstructionsText"></textarea>
                                                        <mat-hint align="end"
                                                            >{{
                                                                detailsFormGroup.controls.pipelineRequestInstructions?.value
                                                                    ?.length ?? 0
                                                            }}/500 characters</mat-hint
                                                        >
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </mat-card-content>
                            </mat-card>

                            <mat-card>
                                <mat-card-header class="mb-2">
                                    <mat-card-title>Candidate Offer Details</mat-card-title>
                                </mat-card-header>
                                <mat-card-content>
                                    <div class="details__item details__gap">
                                        <mat-label class="details__item--label">
                                            {{
                                                offerData?.offerType === offerTypeEnum.Direct
                                                    ? 'Facility'
                                                    : 'Facility *'
                                            }}
                                        </mat-label>
                                        <div
                                            class="flex-row"
                                            [class.gap-4]="urlParent">
                                            @if (offerData?.offerType === offerTypeEnum.Direct) {
                                                @if (urlParent) {
                                                    <a
                                                        class="nova__link"
                                                        target="_blank"
                                                        [routerLink]="[
                                                            '/' + urlParent + '/facilities',
                                                            offerData?.facilityId
                                                        ]"
                                                        rel="noopener"
                                                        >{{ offerData?.facilityName }}</a
                                                    >{{ facilityCityAndState }}
                                                } @else {
                                                    {{ offerData?.facilityName + ' ' + facilityCityAndState }}
                                                }
                                            } @else {
                                                <mat-form-field class="extended-field full-width">
                                                    <input
                                                        type="text"
                                                        matInput
                                                        formControlName="facilityValues"
                                                        [matAutocomplete]="facilityAuto" />
                                                    <mat-autocomplete
                                                        #facilityAuto="matAutocomplete"
                                                        (optionSelected)="facilitySelection($event)"
                                                        [displayWith]="displayFieldName"
                                                        autoActiveFirstOption
                                                        #auto="matAutocomplete">
                                                        @if (filteredFacilityIdOptions) {
                                                            @for (
                                                                option of filteredFacilityIdOptions | async;
                                                                track option.id
                                                            ) {
                                                                <mat-option [value]="option">
                                                                    {{ option.name }} - {{ option.id }}
                                                                </mat-option>
                                                            }
                                                        } @else {
                                                            <mat-option>
                                                                No facilities available to choose from.
                                                            </mat-option>
                                                        }
                                                    </mat-autocomplete>
                                                    <mat-error>Please enter a Facility.</mat-error>
                                                </mat-form-field>
                                            }
                                        </div>
                                    </div>

                                    <div class="details__item details__gap">
                                        <mat-label class="details__item--label">Position Type</mat-label>
                                        <span>{{ offerData?.positionType }}</span>
                                    </div>

                                    <div class="details__item details__gap">
                                        <mat-label class="details__item--label">Unit</mat-label>
                                        @if (offerData?.unitDescriptionFormId) {
                                            <a
                                                class="nova__link"
                                                target="_blank"
                                                rel="noopener"
                                                (click)="openUnitFormUrl($event, offerData?.unitDescriptionFormId)"
                                                >{{ offerData?.unitName }}</a
                                            >
                                        } @else {
                                            <span>{{ offerData?.unitName }}</span>
                                        }
                                    </div>

                                    <div class="details__item details__gap">
                                        <mat-label class="details__item--label">Job Profession</mat-label>
                                        <div>
                                            {{ jobProfessionName || offerData?.jobProfessionName }}
                                        </div>
                                    </div>

                                    <div class="details__item">
                                        <mat-label class="details__item--label">Job Specialty</mat-label>
                                        <mat-form-field class="details__item--control">
                                            <mat-select
                                                formControlName="expertiseId"
                                                (selectionChange)="checkRateUpdateFields('Specialty')"
                                                [disabled]="!detailsFormGroup?.controls.candidateProfessionId.value">
                                                @for (option of expertise; track option.id) {
                                                    <mat-option [value]="option.id">
                                                        {{ option.name }}
                                                    </mat-option>
                                                }
                                            </mat-select>
                                            @if (isDifferent('specialty')) {
                                                <mat-hint class="diff-line"
                                                    >OFFER:
                                                    <span class="diff-value">{{
                                                        snapshotData().jobDetails?.specialty
                                                    }}</span></mat-hint
                                                >
                                            }
                                        </mat-form-field>
                                    </div>

                                    <div class="details__item details__gap">
                                        <mat-label class="details__item--label">Payroll Workweek</mat-label>
                                        <span>{{ offerData?.payrollWorkweek }}</span>
                                    </div>

                                    <div class="details__item">
                                        <mat-label class="details__item--label">Contract Length</mat-label>
                                        <div class="contract-length-controls">
                                            <div class="flex-row">
                                                <mat-form-field class="details__item--control contractLength">
                                                    <input
                                                        type="number"
                                                        matInput
                                                        (change)="calculateContractDates('weeksLengthChanged')"
                                                        formControlName="contractLength" />
                                                    <mat-error>Please enter valid Weeks Length.</mat-error>
                                                    @if (isDifferent('contractLength')) {
                                                        <mat-hint class="diff-line"
                                                            >OFFER:
                                                            <span class="diff-value">{{
                                                                snapshotData().jobDetails?.length
                                                            }}</span></mat-hint
                                                        >
                                                    }
                                                </mat-form-field>
                                                <span class="control-suffix ml-1">Weeks</span>
                                            </div>
                                            <div class="flex-row">
                                                <mat-form-field class="details__item--control contractLength">
                                                    <input
                                                        type="number"
                                                        matInput
                                                        (change)="calculateContractDates('daysLengthChanged')"
                                                        formControlName="contractLengthDays" />
                                                    <mat-error>Please enter valid Days Length.</mat-error>
                                                </mat-form-field>
                                                <span class="control-suffix ml-1">Days</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="details__item">
                                        <mat-label class="details__item--label">{{
                                            offerData?.offerType === offerTypeEnum.Direct ? 'Start *' : 'Start'
                                        }}</mat-label>
                                        <mat-form-field class="details__item--control">
                                            <input
                                                matInput
                                                [matDatepicker]="picker"
                                                formControlName="startDate"
                                                (dateChange)="calculateContractDates('startDateChanged')" />
                                            <mat-datepicker-toggle
                                                matSuffix
                                                [for]="picker"></mat-datepicker-toggle>
                                            <mat-datepicker #picker></mat-datepicker>
                                            @if (detailsFormGroup.controls['startDate'].invalid) {
                                                <mat-error>Please enter valid start date.</mat-error>
                                            }
                                            @if (isDifferent('startDate')) {
                                                <mat-hint class="diff-line"
                                                    >OFFER:
                                                    <span class="diff-value">{{
                                                        snapshotData().jobDetails?.startDate | date: 'MM/dd/yyyy'
                                                    }}</span></mat-hint
                                                >
                                            }
                                        </mat-form-field>
                                    </div>

                                    <div class="details__item">
                                        <mat-label class="details__item--label">
                                            {{ offerData?.offerType === offerTypeEnum.Direct ? 'End *' : 'End' }}
                                        </mat-label>
                                        <mat-form-field class="details__item--control">
                                            <input
                                                matInput
                                                [matDatepicker]="endPicker"
                                                formControlName="endDate"
                                                [min]="minEndDate"
                                                (dateChange)="calculateContractDates('endDateChanged')" />
                                            <mat-datepicker-toggle
                                                matSuffix
                                                [for]="endPicker"></mat-datepicker-toggle>
                                            <mat-datepicker #endPicker></mat-datepicker>
                                            @if (detailsFormGroup.controls['endDate'].invalid) {
                                                <mat-error>Please enter valid end date.</mat-error>
                                            }
                                        </mat-form-field>
                                    </div>

                                    <div class="details__item details__gap">
                                        <mat-label class="details__item--label">RTO</mat-label>
                                        <mat-checkbox
                                            class="nml-6"
                                            formControlName="hasRequestedTimeOff"></mat-checkbox>
                                    </div>

                                    @if (detailsFormGroup.controls.hasRequestedTimeOff.value) {
                                        <div class="details__item details__gap">
                                            <mat-label class="details__item--label">RTO Dates</mat-label>
                                            <div class="flex-col gap-4">
                                                <div class="flex-row">
                                                    <div class="rto-container flex-row">
                                                        <div class="calendar-control">
                                                            <div class="days">
                                                                <span>{{ daysRequested }}</span>
                                                            </div>
                                                            <button
                                                                class="rto-btn"
                                                                mat-icon-button
                                                                [matMenuTriggerFor]="appMenu">
                                                                <mat-icon>event</mat-icon>
                                                            </button>
                                                        </div>
                                                        <mat-menu
                                                            #appMenu="matMenu"
                                                            class="drop-calendar">
                                                            <div (click)="$event.stopPropagation()">
                                                                <mat-calendar
                                                                    #calendar
                                                                    class="mat-calendar"
                                                                    [dateClass]="dateClass()"
                                                                    [maxDate]="maxDate"
                                                                    [minDate]="minDate"
                                                                    (selectedChange)="
                                                                        dateChanged($event)
                                                                    "></mat-calendar>
                                                            </div>
                                                        </mat-menu>
                                                        <a
                                                            class="nova-link rto-clear__btn"
                                                            [class.disabled]="daysSelected.length ? false : true"
                                                            (click)="clearDates()"
                                                            (keydown.enter)="clearDates()"
                                                            #clearCalendarTrigger="matMenuTrigger"
                                                            [matMenuTriggerFor]="appMenu"
                                                            >Clear</a
                                                        >
                                                    </div>
                                                </div>
                                                @if (isDifferent('rto')) {
                                                    <span class="diff-line ml-0"
                                                        >OFFER:

                                                        <span class="diff-value flex-i">
                                                            @for (date of snapshotRtoDisplay; track date) {
                                                                {{ date }}<br />
                                                            }</span
                                                    ></span>
                                                }
                                                @if (showRTOAlertOnStartEndDates) {
                                                    <div class="offer-rto-warning">
                                                        <nova-rto-warning-message
                                                            [enabled]="showRTOAlertOnStartEndDates">
                                                        </nova-rto-warning-message>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div class="details__item">
                                            <mat-label class="details__item--label">RTO Approval</mat-label>
                                            <mat-form-field class="details__item--control">
                                                <mat-select
                                                    formControlName="rtoApprovalStatus"
                                                    data-qa-id="RTOApprovalStatusEdit">
                                                    <mat-option [value]="1">Approved</mat-option>
                                                    <mat-option [value]="2">Pending Approval</mat-option>
                                                    <mat-option [value]="3">Not Approved</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    }

                                    <div class="details__item">
                                        <mat-label class="details__item--label">Shift Type*</mat-label>
                                        <mat-form-field class="details__item--control">
                                            <mat-select formControlName="shiftTypeId">
                                                @for (option of lookups?.shiftTypes; track option.key) {
                                                    <mat-option [value]="option.key">
                                                        {{ option.value }}
                                                    </mat-option>
                                                }
                                            </mat-select>
                                            @if (hasError('shiftTypeId', 'required')) {
                                                <mat-error>Shift Type is required</mat-error>
                                            }
                                            @if (isDifferent('shiftType')) {
                                                <mat-hint class="diff-line"
                                                    >OFFER:
                                                    <span class="diff-value">{{ shiftTypeName }}</span></mat-hint
                                                >
                                            }
                                        </mat-form-field>
                                    </div>

                                    <div class="details__item">
                                        <mat-label class="details__item--label">Number of Shifts*</mat-label>
                                        <div
                                            class="flex-row details__item--control">
                                            <mat-form-field>
                                                <mat-select
                                                    formControlName="shifts"
                                                    (selectionChange)="calculateContractDates('numOfShiftsChanged')">
                                                    @for (num of shiftValues; track num) {
                                                        <mat-option [value]="num">{{ num }}</mat-option>
                                                    }
                                                </mat-select>
                                                @if (hasError('shifts', 'required')) {
                                                    <mat-error>Number of Shifts is required</mat-error>
                                                }
                                                @if (isDifferent('shifts')) {
                                                    <mat-hint class="diff-line"
                                                        >OFFER:
                                                        <span class="diff-value">{{
                                                            snapshotData().jobDetails?.shiftDetails?.shifts
                                                        }}</span></mat-hint
                                                    >
                                                }
                                            </mat-form-field>
                                            @if (viewAltShift) {
                                                <mat-form-field class="ml-2">
                                                    <mat-select formControlName="shiftsAlt">
                                                        @for (num of shiftValues; track num) {
                                                            <mat-option [value]="num">{{ num }}</mat-option>
                                                        }
                                                    </mat-select>
                                                    @if (hasError('shiftsAlt', 'required')) {
                                                        <mat-error>Number of Alt Shifts is required</mat-error>
                                                    }
                                                    @if (isDifferent('shiftsAlt')) {
                                                        <mat-hint class="diff-line"
                                                            >OFFER:
                                                            <span class="diff-value">{{
                                                                snapshotData().jobDetails?.shiftDetails?.shiftsAlt
                                                            }}</span></mat-hint
                                                        >
                                                    }
                                                </mat-form-field>
                                            }
                                        </div>
                                    </div>

                                    <div class="details__item">
                                        <mat-label class="details__item--label">Shift Length in Hours*</mat-label>
                                        <div class="flex-row details__item--control">
                                            <mat-form-field>
                                                <mat-select
                                                    formControlName="hours"
                                                    (selectionChange)="checkRateUpdateFields('Shift Length')">
                                                    @for (length of hoursValue; track length) {
                                                        <mat-option [value]="length">{{ length }}</mat-option>
                                                    }
                                                </mat-select>
                                                @if (hasError('hours', 'required')) {
                                                    <mat-error>Shift Length is required</mat-error>
                                                }
                                                @if (isDifferent('shiftLength')) {
                                                    <mat-hint class="diff-line"
                                                        >OFFER:
                                                        <span class="diff-value">{{
                                                            snapshotData().jobDetails?.shiftDetails?.hours
                                                        }}</span></mat-hint
                                                    >
                                                }
                                            </mat-form-field>
                                            @if (viewAltShift) {
                                                <mat-form-field class="ml-2">
                                                    <mat-select
                                                        formControlName="hoursAlt"
                                                        (selectionChange)="onShiftLengthAltChanged()">
                                                        @for (length of hoursValue; track length) {
                                                            <mat-option [value]="length">
                                                                {{ length }}
                                                            </mat-option>
                                                        }
                                                    </mat-select>
                                                    @if (hasError('hoursAlt', 'required')) {
                                                        <mat-error>Alt Shift Length is required</mat-error>
                                                    }
                                                    @if (isDifferent('shiftAltLength')) {
                                                        <mat-hint class="diff-line"
                                                            >OFFER:
                                                            <span class="diff-value">{{
                                                                snapshotData().jobDetails?.shiftDetails?.hoursAlt
                                                            }}</span></mat-hint
                                                        >
                                                    }
                                                </mat-form-field>
                                            }
                                        </div>
                                    </div>

                                    <div class="details__item">
                                        <mat-label class="details__item--label">Shift Time of Day*</mat-label>
                                        <div
                                            class="flex-row details__item--control">
                                            <mat-form-field>
                                                <mat-select
                                                    formControlName="shiftTimeOfDayId"
                                                    (selectionChange)="checkRateUpdateFields('Shift Type')">
                                                    @for (option of lookups?.shiftTimes; track option.key) {
                                                        <mat-option [value]="option.key">
                                                            {{ option.value }}
                                                        </mat-option>
                                                    }
                                                </mat-select>
                                                @if (hasError('shiftTimeOfDayId', 'required')) {
                                                    <mat-error>Shift Time of Day is required</mat-error>
                                                }
                                            </mat-form-field>
                                            @if (viewAltShift || isRotatingShift) {
                                                <mat-form-field class="ml-2">
                                                    <mat-select formControlName="shiftAltTimeOfDayId">
                                                        @for (option of lookups?.shiftTimes; track option.key) {
                                                            <mat-option [value]="option.key">
                                                                {{ option.value }}
                                                            </mat-option>
                                                        }
                                                    </mat-select>
                                                    @if (hasError('shiftAltTimeOfDayId', 'required')) {
                                                        <mat-error>Alt Shift Time of Day is required</mat-error>
                                                    }
                                                </mat-form-field>
                                            }
                                        </div>
                                    </div>

                                    <div class="details__item details__gap">
                                        <mat-label class="details__item--label">Shift Time (optional)</mat-label>
                                        <div
                                            class="flex-row details__item--control gap-4"
                                            [class.gap-16]="viewAltShift || isRotatingShift">
                                            <div class="flex-col flex-1">
                                                <div class="flex-col gap-8">
                                                    <div class="flex-col gap-4">
                                                        <span class="nova__label">Start</span>
                                                        <kendo-timepicker
                                                            class="kendo-input-field"
                                                            formControlName="shiftTimeStart"
                                                            (valueChange)="onTimeStartChanged($event)"
                                                            format="HH:mm">
                                                        </kendo-timepicker>
                                                        <span class="diff-line diff-static ml-0">
                                                            @if (isDifferent('shiftTimeStart')) {
                                                                OFFER:
                                                                <span class="diff-value"
                                                                    >{{
                                                                        snapshotData().jobDetails?.shiftDetails
                                                                            ?.shiftH ?? 0 | number: '2.0'
                                                                    }}:{{
                                                                        snapshotData().jobDetails?.shiftDetails
                                                                            ?.shiftM ?? 0 | number: '2.0'
                                                                    }}</span
                                                                >
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="flex-col gap-8">
                                                    <div class="flex-col gap-4">
                                                        <span class="nova__label">End</span>
                                                        <kendo-timepicker
                                                            class="kendo-input-field"
                                                            formControlName="shiftTimeEnd"
                                                            (valueChange)="onTimeEndChanged($event)"
                                                            format="HH:mm">
                                                        </kendo-timepicker>
                                                        <span class="diff-line diff-static ml-0">
                                                            @if (isDifferent('shiftTimeEnd')) {
                                                                OFFER:
                                                                <span class="diff-value">
                                                                    {{
                                                                        snapshotData().jobDetails?.shiftDetails
                                                                            ?.shiftToH ?? 0 | number: '2.0'
                                                                    }}:{{
                                                                        snapshotData().jobDetails?.shiftDetails
                                                                            ?.shiftToM ?? 0 | number: '2.0'
                                                                    }}
                                                                </span>
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            @if (viewAltShift || isRotatingShift) {
                                                <div class="flex-col flex-1">
                                                    <div class="flex-col gap-4">
                                                        <span class="nova__label">Start</span>
                                                        <kendo-timepicker
                                                            class="kendo-input-field"
                                                            formControlName="shiftAltTimeStart"
                                                            (valueChange)="onAltTimeStartChanged($event)"
                                                            format="HH:mm">
                                                        </kendo-timepicker>
                                                        <span class="diff-line diff-static ml-0">
                                                            @if (isDifferent('shiftAltTimeStart')) {
                                                                OFFER:
                                                                <span class="diff-value"
                                                                    >{{
                                                                        snapshotData().jobDetails?.shiftDetails
                                                                            ?.shiftAltH ?? 0 | number: '2.0'
                                                                    }}:{{
                                                                        snapshotData().jobDetails?.shiftDetails
                                                                            ?.shiftAltM ?? 0 | number: '2.0'
                                                                    }}</span
                                                                >
                                                            }
                                                        </span>
                                                    </div>
                                                    <div class="flex-col gap-4">
                                                        <span class="nova__label">End</span>
                                                        <kendo-timepicker
                                                            class="kendo-input-field"
                                                            formControlName="shiftAltTimeEnd"
                                                            (valueChange)="onAltTimeEndChanged($event)"
                                                            format="HH:mm">
                                                        </kendo-timepicker>
                                                        <span class="diff-line diff-static ml-0">
                                                            @if (isDifferent('shiftAltTimeEnd')) {
                                                                OFFER:
                                                                <span class="diff-value"
                                                                    >{{
                                                                        snapshotData().jobDetails?.shiftDetails
                                                                            ?.shiftAltToH ?? 0 | number: '2.0'
                                                                    }}:{{
                                                                        snapshotData().jobDetails?.shiftDetails
                                                                            ?.shiftAltToM ?? 0 | number: '2.0'
                                                                    }}</span
                                                                >
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>

                                    <div class="details__item">
                                        <mat-label class="details__item--label">Shift Details</mat-label>
                                        <div class="flex-col flex-1">
                                            <mat-form-field>
                                                <textarea
                                                    matInput
                                                    class="textarea-control"
                                                    formControlName="shiftDetails"></textarea>
                                                <mat-hint
                                                    class="textarea-control-hint"
                                                    align="end"
                                                    >{{ detailsFormGroup.controls.shiftDetails.value?.length }}/1500
                                                    characters</mat-hint
                                                >
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </mat-card-content>
                            </mat-card>
                        </form>
                    </div>
                </div>
            } @else {
                <nova-shared-offer-details-view
                    [offerData]="offerData"
                    [showSampleMarginButton]="showSampleMarginButton()"
                    [showImportMarginButton]="showImportMarginButton()"
                    [showCreateAndImportMarginButtons]="showCreateAndImportMarginButtons()"
                    [showOfferMarginDifferences]="offerMarginDifferences && offerMarginDifferences.length > 0"
                    [displayedContractLengthWeeks]="displayedContractLengthWeeks"
                    [displayedContractLengthDays]="displayedContractLengthDays"
                    [endDateTextWithoutWeeks]="endDateTextWithoutWeeks"
                    [showRTOAlertOnStartEndDates]="showRTOAlertOnStartEndDates"
                    [isWfdReturner]="isWfdReturner$ | async"
                    [wfdPriority]="wfdPriority$ | async"
                    [urlParent]="urlParent"
                    [userType]="userType"
                    (goToJobId)="goToJobId($event)"
                    (duplicateSampleMargin)="duplicateSampleMargin()"
                    (showImportMarginDialog)="showImportMarginDialog()"
                    (createOfferMargin)="createOfferMargin()"
                    (openMarginCalculator)="openMarginCalculator($event)"
                    (openMarginDifferences)="openMarginDifferences()"
                    (openFacility)="openFacility($event)"
                    (openUnitFormUrl)="openUnitFormUrl($event.event, $event.unitFormId)"
                    (goToContractRequest)="goToContractRequest($event.contractRequestId, $event.marginId)">
                </nova-shared-offer-details-view>
            }
        } @else {
            <mat-card class="info">
                <mat-card-content>
                    <form [formGroup]="detailsFormGroup">
                        <table
                            class="offer-info-table"
                            aria-label="table">
                            <tbody>
                                <tr class="hidden">
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                </tr>
                                <ng-container *ngIf="offerData?.offerType !== offerTypeEnum.Direct">
                                    <tr>
                                        <td><span class="label-text">Vendor</span></td>
                                        <td>
                                            <span>{{ offerData?.vendorName }}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><span class="label-text">Vendor Contact</span></td>
                                        <td>
                                            <mat-form-field
                                                *ngIf="editMode"
                                                class="mc-form-field mc-form-field__shift-type--width">
                                                <mat-select formControlName="vendorContactId">
                                                    <mat-option
                                                        *ngFor="let option of vendorLookups?.contacts"
                                                        [value]="option.id"
                                                        >{{ option.name }}</mat-option
                                                    >
                                                </mat-select>
                                            </mat-form-field>
                                            <span *ngIf="!editMode"
                                                ><a
                                                    class="nova__link"
                                                    href="mailto:{{ offerData?.vendorContactEmail }}"
                                                    >{{ offerData?.vendorContactName }}</a
                                                ></span
                                            >
                                        </td>
                                    </tr>
                                </ng-container>

                                <tr>
                                    <td><span class="label-text">Candidate</span></td>
                                    <td>
                                        <span>
                                            <a
                                                *ngIf="!editMode && urlParent && offerData?.candidateId"
                                                class="nova__link"
                                                target="_blank"
                                                [routerLink]="[
                                                    '/recruiting/candidates',
                                                    offerData?.candidateId,
                                                    'new-profile'
                                                ]"
                                                rel="noopener"
                                                >{{ offerData?.candidateName }}</a
                                            >
                                            <span *ngIf="editMode">{{ offerData?.candidateName }}</span>
                                            <span *ngIf="!offerData?.candidateId">{{ offerData?.candidateName }}</span>
                                            ({{ offerData?.candidateEmail }})
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td><span class="label-text">Offer Status</span></td>
                                    <td>
                                        <span *ngIf="!editMode">{{ offerData?.status }}</span>
                                        <span *ngIf="editMode">{{ detailsFormGroup?.controls.status.value }}</span>
                                    </td>
                                </tr>
                                @if (
                                    offerData?.hospitalTypeId === hospTypeEnum.WorkforceDisruptionClinical ||
                                    offerData?.hospitalTypeId === hospTypeEnum.WorkforceDisruptionNonClinical
                                ) {
                                    <tr>
                                        <td>
                                            <span class="label-text">WFD Priority</span>
                                        </td>
                                        <td>
                                            <span>
                                                <nova-wfd-priority-returner-chips-view
                                                    [wfdPriority]="wfdPriority$ | async"
                                                    [isWfdReturner]="isWfdReturner$ | async" />
                                            </span>
                                        </td>
                                    </tr>
                                }
                                <tr>
                                    <td colspan="2"></td>
                                </tr>
                                <tr>
                                    <td><span class="label-text">Contract Type</span></td>
                                    <td>
                                        <span *ngIf="!editMode">{{ offerData?.contractType }}</span>
                                        <mat-form-field
                                            *ngIf="editMode"
                                            class="mc-form-field mc-form-field__shift-type--width">
                                            <mat-select formControlName="contractTypeId">
                                                <mat-option
                                                    *ngFor="let option of lookups?.contracts"
                                                    [value]="option.id"
                                                    >{{ option.code }}</mat-option
                                                >
                                            </mat-select>
                                        </mat-form-field>
                                    </td>
                                </tr>

                                <tr>
                                    <td><span class="label-text">Contract Status</span></td>
                                    <td>
                                        <span
                                            (click)="
                                                goToContractRequest(offerData?.contractRequestId, offerData?.marginId)
                                            "
                                            class="nova__link"
                                            >{{ offerData?.contractRequestStatus }}</span
                                        >
                                    </td>
                                </tr>

                                <tr>
                                    <td><span class="label-text">Position Type</span></td>
                                    <td>
                                        <span>{{ offerData?.positionType }}</span>
                                    </td>
                                </tr>
                                <tr *ngIf="offerData?.offerType === offerTypeEnum.Direct">
                                    <td><span class="label-text">Unit</span></td>
                                    <td>
                                        <ng-container *ngIf="offerData?.unitDescriptionFormId; else unitNameText">
                                            <a
                                                (click)="openUnitFormUrl($event, offerData?.unitDescriptionFormId)"
                                                class="nova__link"
                                                target="_blank"
                                                rel="noopener"
                                                >{{ offerData?.unitName }}</a
                                            >
                                        </ng-container>
                                        <ng-template #unitNameText>
                                            <span>{{ offerData?.unitName }}</span>
                                        </ng-template>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2"></td>
                                </tr>
                                <tr>
                                    <td>
                                        <span class="label-text">{{
                                            !editMode || offerData?.offerType === offerTypeEnum.Direct
                                                ? 'Facility'
                                                : 'Facility *'
                                        }}</span>
                                    </td>
                                    <td>
                                        <ng-container>
                                            <a
                                                *ngIf="!editMode"
                                                (click)="openFacility(offerData?.facilityId)"
                                                class="nova__link"
                                                >{{ offerData?.facilityName }}</a
                                            >
                                            <span *ngIf="!urlParent && editMode">{{ offerData?.facilityName }}</span>
                                        </ng-container>

                                        <ng-container
                                            *ngIf="
                                                offerData?.offerType === offerTypeEnum.Direct;
                                                else facilityNonDirect
                                            ">
                                            <a
                                                *ngIf="urlParent && editMode"
                                                class="nova__link"
                                                target="_blank"
                                                [routerLink]="['/' + urlParent + '/facilities', offerData?.facilityId]"
                                                rel="noopener"
                                                >{{ offerData?.facilityName }}</a
                                            >
                                        </ng-container>
                                        <ng-template #facilityNonDirect>
                                            <mat-form-field
                                                *ngIf="editMode"
                                                class="extended-field full-width">
                                                <input
                                                    type="text"
                                                    matInput
                                                    formControlName="facilityValues"
                                                    [matAutocomplete]="facilityAuto" />
                                                <mat-autocomplete
                                                    #facilityAuto="matAutocomplete"
                                                    (optionSelected)="facilitySelection($event)"
                                                    [displayWith]="displayFieldName"
                                                    autoActiveFirstOption
                                                    #auto="matAutocomplete">
                                                    <mat-option
                                                        *ngFor="let option of filteredFacilityIdOptions | async"
                                                        [value]="option">
                                                        {{ option.name }} - {{ option.id }}
                                                    </mat-option>
                                                    <mat-option *ngIf="!filteredFacilityIdOptions"
                                                        >No facilities available to choose from.</mat-option
                                                    >
                                                </mat-autocomplete>
                                                <mat-error>Please enter a Facility.</mat-error>
                                            </mat-form-field>
                                        </ng-template>
                                    </td>
                                </tr>
                                <tr>
                                    <td><span class="label-text">Facility Address</span></td>
                                    <td>
                                        <div *ngIf="offerData?.facilityAddress">
                                            {{ offerData.facilityAddress }}
                                        </div>
                                        <div
                                            *ngIf="
                                                offerData?.facilityCity &&
                                                offerData?.facilityState &&
                                                offerData?.facilityZip
                                            ">
                                            {{ offerData.facilityCity }}, {{ offerData.facilityState }}
                                            {{ offerData.facilityZip }}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td><span class="label-text">AM</span></td>
                                    <td>
                                        <span *ngIf="!editMode">{{ offerData?.accountManagerName }}</span>
                                        <span *ngIf="editMode">{{ facilityLookup?.accountManager }}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td><span class="label-text">Job ID</span></td>
                                    <td>
                                        <span
                                            *ngIf="!editMode"
                                            (click)="goToJobId(offerData.jobId)"
                                            class="nova__link"
                                            >{{ offerData?.jobId }}</span
                                        >
                                        <mat-form-field *ngIf="editMode">
                                            <input
                                                type="number"
                                                matInput
                                                formControlName="jobId"
                                                [matAutocomplete]="jobIdAuto"
                                                (change)="jobIdSelection($event)" />
                                            <mat-autocomplete
                                                #jobIdAuto="matAutocomplete"
                                                [displayWith]="displayJobIds"
                                                (optionSelected)="jobIdSelection($event)">
                                                <mat-option
                                                    *ngFor="let job of filteredJobIdOptions | async"
                                                    [value]="job"
                                                    >{{ job }}
                                                </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field>
                                    </td>
                                </tr>
                                <ng-container *ngIf="showSampleMarginButton()">
                                    <tr class="margin-btn-container">
                                        <td><span class="label-text">Offer Margin</span></td>
                                        <td>
                                            <ng-container>
                                                <button
                                                    mat-flat-button
                                                    data-qa-id="addSampleMargin"
                                                    class="margin-btn"
                                                    color="primary"
                                                    (click)="duplicateSampleMargin()"
                                                    [disabled]="disableSampleMargin()"
                                                    [matTooltip]="sampleMarginTooltip()">
                                                    ADD SAMPLE MARGIN
                                                </button>
                                            </ng-container>
                                        </td>
                                    </tr>
                                </ng-container>
                                <ng-container *ngIf="showCreateAndImportMarginButtons()">
                                    <tr class="margin-btn-container">
                                        <td><span class="label-text">Offer Margin</span></td>
                                        <td>
                                            <ng-container>
                                                <button
                                                    mat-flat-button
                                                    color="primary"
                                                    (click)="showImportMarginDialog()">
                                                    IMPORT MARGIN
                                                </button>
                                            </ng-container>
                                            <ng-container>
                                                <button
                                                    mat-stroked-button
                                                    color="secondary"
                                                    (click)="createOfferMargin()">
                                                    CREATE MARGIN
                                                </button>
                                            </ng-container>
                                        </td>
                                    </tr>
                                </ng-container>
                                <tr *ngIf="offerData?.marginId">
                                    <td><span class="label-text">Offer Margin</span></td>
                                    <td>
                                        <span>
                                            <a
                                                (click)="openMarginCalculator(offerData?.marginId)"
                                                class="nova__link ng-star-inserted"
                                                >{{ offerData?.marginId }}</a
                                            >
                                            <ng-container *ngIf="offerData?.importedFromMarginId">
                                                (Margin created from {{ offerData?.importedFromMarginId }} margin
                                                {{ offerData?.marginImportDateUtc | date: 'MM/dd/yyyy - hh:mm a' }})
                                            </ng-container>
                                        </span>
                                    </td>
                                </tr>

                                <ng-container *ngIf="showImportMarginButton()">
                                    <ng-container>
                                        <tr>
                                            <td></td>
                                            <td>
                                                <button
                                                    mat-flat-button
                                                    class="margin-btn"
                                                    color="primary"
                                                    (click)="showImportMarginDialog()">
                                                    IMPORT MARGIN
                                                </button>
                                            </td>
                                        </tr>
                                    </ng-container>
                                </ng-container>

                                <tr
                                    class="pt-0"
                                    *ngIf="offerMarginDifferences && offerMarginDifferences.length">
                                    <td><span class="label-text"></span></td>
                                    <td>
                                        <span
                                            (click)="openMarginDifferences()"
                                            class="nova__link ng-star-inserted"
                                            >View Differences</span
                                        >
                                    </td>
                                </tr>

                                <tr>
                                    <td colspan="2"></td>
                                </tr>

                                <tr>
                                    <td>
                                        <span class="label-text">Candidate Profession</span>
                                    </td>
                                    <td>
                                        <span>{{ offerData?.professionName }}</span>
                                    </td>
                                </tr>

                                <ng-container>
                                    <tr>
                                        <td>
                                            <span class="label-text">Job Profession</span>
                                        </td>
                                        <td>
                                            <span>{{ jobProfessionName || offerData?.jobProfessionName }}</span>
                                        </td>
                                    </tr>
                                    <tr *ngIf="validateCandidateProfessionJobs">
                                        <td colspan="2">
                                            <mat-error
                                                >Clinician's profession must match the job's profession. Please review
                                                and update before creating an Offer.</mat-error
                                            >
                                        </td>
                                    </tr>
                                </ng-container>
                                <tr
                                    *ngIf="!editMode && offerData?.isRemoteBooking !== null"
                                    data-qa-id="job-details-work-model">
                                    <td><span class="label-text">Work Model</span></td>
                                    <td>
                                        <span data-qa-id="ProfessionView">{{
                                            !offerData?.isRemoteBooking ? 'Onsite' : 'Remote'
                                        }}</span>
                                    </td>
                                </tr>
                                <tr
                                    *ngIf="editMode && offerData?.isRemoteBooking !== null"
                                    data-qa-id="job-details-work-model">
                                    <td>
                                        <span class="label-text">Work Model</span>
                                    </td>
                                    <td>
                                        <mat-radio-group
                                            formControlName="isRemoteBooking"
                                            name="isRemoteBooking"
                                            data-qa-id="job-details-work-model-radio">
                                            <mat-radio-button
                                                class="mx-2"
                                                [value]="false"
                                                >Onsite</mat-radio-button
                                            >
                                            <mat-radio-button
                                                class="mx-2"
                                                [value]="true"
                                                >Remote</mat-radio-button
                                            >
                                        </mat-radio-group>
                                    </td>
                                </tr>
                                <tr
                                    *ngIf="offerData?.isPatientFacing !== null"
                                    data-qa-id="job-details-work-type">
                                    <td><span class="label-text">Work Type</span></td>
                                    <td>
                                        <span>{{
                                            (offerData?.isPatientFacing ?? true)
                                                ? 'Patient-Facing'
                                                : 'Non-Patient-Facing'
                                        }}</span>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <span class="label-text">Job Specialty</span>
                                    </td>
                                    <td>
                                        <span *ngIf="!editMode">{{ offerData?.expertiseName }}</span>
                                        <mat-form-field
                                            *ngIf="editMode"
                                            class="mc-form-field mc-form-field__shift-type--width extended-field">
                                            <mat-select
                                                formControlName="expertiseId"
                                                (selectionChange)="checkRateUpdateFields('Specialty')"
                                                [disabled]="!detailsFormGroup?.controls.candidateProfessionId.value">
                                                <mat-option
                                                    *ngFor="let option of expertise"
                                                    [value]="option.id"
                                                    >{{ option.name }}</mat-option
                                                >
                                            </mat-select>
                                        </mat-form-field>
                                    </td>
                                </tr>

                                <tr>
                                    <td colspan="2"></td>
                                </tr>
                                <ng-container>
                                    <tr>
                                        <td>
                                            <span class="label-text">Contract Length</span>
                                        </td>
                                        <td *ngIf="editMode">
                                            <div>
                                                <mat-form-field class="contractLength">
                                                    <input
                                                        type="number"
                                                        matInput
                                                        (change)="calculateContractDates('weeksLengthChanged')"
                                                        formControlName="contractLength" />
                                                    <mat-error>Please enter valid Weeks Length.</mat-error>
                                                </mat-form-field>
                                                <span class="label-text"> Weeks</span>
                                            </div>
                                            <div>
                                                <mat-form-field class="contractLength">
                                                    <input
                                                        type="number"
                                                        matInput
                                                        (change)="calculateContractDates('daysLengthChanged')"
                                                        formControlName="contractLengthDays" />
                                                    <mat-error>Please enter valid Days Length.</mat-error>
                                                </mat-form-field>
                                                <span class="label-text"> Days</span>
                                                <mat-icon
                                                    *ngIf="contractLengthDaysApprovalRequired"
                                                    class="info-icon"
                                                    [matTooltip]="contractLengthDaysInfoMessage"
                                                    >info</mat-icon
                                                >
                                            </div>
                                        </td>
                                        <td *ngIf="!editMode">
                                            <div class="weekDaysDisplay">
                                                <span>{{ displayedContractLengthWeeks }} Weeks</span>
                                            </div>
                                            <div>
                                                <span>{{ displayedContractLengthDays }} Days</span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            ><span class="label-text">
                                                {{
                                                    editMode && offerData?.offerType === offerTypeEnum.Direct
                                                        ? 'Start *'
                                                        : 'Start'
                                                }}</span
                                            ></td
                                        >
                                        <td>
                                            <span *ngIf="!editMode">{{ offerData?.startDate }}</span>
                                            <mat-form-field *ngIf="editMode">
                                                <input
                                                    matInput
                                                    [matDatepicker]="picker"
                                                    formControlName="startDate"
                                                    (dateChange)="calculateContractDates('startDateChanged')" />
                                                <mat-datepicker-toggle
                                                    matSuffix
                                                    [for]="picker"></mat-datepicker-toggle>
                                                <mat-datepicker #picker></mat-datepicker>
                                                <mat-error>Please enter valid start date.</mat-error>
                                            </mat-form-field>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            ><span class="label-text">{{
                                                editMode && offerData?.offerType === offerTypeEnum.Direct
                                                    ? 'End *'
                                                    : 'End'
                                            }}</span></td
                                        >
                                        <td>
                                            <span *ngIf="!editMode">{{ endDateTextWithoutWeeks }}</span>
                                            <mat-form-field *ngIf="editMode">
                                                <input
                                                    matInput
                                                    [matDatepicker]="picker"
                                                    formControlName="endDate"
                                                    [min]="minEndDate"
                                                    (dateChange)="calculateContractDates('endDateChanged')" />
                                                <mat-datepicker-toggle
                                                    matSuffix
                                                    [for]="picker"></mat-datepicker-toggle>
                                                <mat-datepicker #picker></mat-datepicker>
                                                <mat-error>Please enter valid end date.</mat-error>
                                            </mat-form-field>
                                        </td>
                                    </tr>
                                </ng-container>

                                <tr *ngIf="!editMode">
                                    <td><span class="label-text">Shifts</span></td>
                                    <td>
                                        <span>{{ offerData?.shiftsText }}</span>
                                    </td>
                                </tr>

                                <ng-container>
                                    <tr *ngIf="editMode">
                                        <td>
                                            <span class="label-text">Shift Type <span>*</span></span>
                                        </td>
                                        <td>
                                            <mat-form-field class="mc-form-field mc-form-field__shift-type--width">
                                                <mat-select formControlName="shiftTypeId">
                                                    <mat-option
                                                        *ngFor="let option of lookups?.shiftTypes"
                                                        [value]="option.key"
                                                        >{{ option.value }}</mat-option
                                                    >
                                                </mat-select>
                                                <mat-error *ngIf="hasError('shiftTypeId', 'required')"
                                                    >Shift Type is required</mat-error
                                                >
                                            </mat-form-field>
                                        </td>
                                    </tr>

                                    <tr *ngIf="editMode">
                                        <td>
                                            <span class="label-text"># of Shifts <span>*</span></span>
                                        </td>
                                        <td [ngClass]="{ twoColTd: viewAltShift }">
                                            <mat-form-field
                                                class="mc-form-field mc-form-field__shift-type--width tdSplit">
                                                <mat-select
                                                    formControlName="shifts"
                                                    (selectionChange)="calculateContractDates('numOfShiftsChanged')">
                                                    <mat-option
                                                        *ngFor="let num of shiftValues"
                                                        [value]="num"
                                                        >{{ num }}</mat-option
                                                    >
                                                </mat-select>
                                                <mat-error *ngIf="hasError('shifts', 'required')"
                                                    ># of Shifts is required</mat-error
                                                >
                                            </mat-form-field>

                                            <mat-form-field
                                                *ngIf="viewAltShift"
                                                class="mc-form-field mc-form-field__shift-type--width tdSplit">
                                                <mat-select formControlName="shiftsAlt">
                                                    <mat-option
                                                        *ngFor="let num of shiftValues"
                                                        [value]="num"
                                                        >{{ num }}</mat-option
                                                    >
                                                </mat-select>
                                                <mat-error *ngIf="hasError('shiftsAlt', 'required')"
                                                    ># of Alt Shifts is required</mat-error
                                                >
                                            </mat-form-field>
                                        </td>
                                    </tr>

                                    <tr *ngIf="editMode">
                                        <td>
                                            <span class="label-text">Shift Length <span>*</span></span>
                                        </td>
                                        <td [ngClass]="{ twoColTd: viewAltShift }">
                                            <div class="tdSplit">
                                                <mat-form-field class="mc-form-field mc-form-field__shift-type--width">
                                                    <mat-select
                                                        formControlName="hours"
                                                        (selectionChange)="checkRateUpdateFields('Shift Length')">
                                                        <mat-option
                                                            *ngFor="let length of hoursValue"
                                                            [value]="length"
                                                            >{{ length }}</mat-option
                                                        >
                                                    </mat-select>
                                                    <mat-error *ngIf="hasError('hours', 'required')"
                                                        >Shift Length is required</mat-error
                                                    >
                                                </mat-form-field>
                                                <span class="label-text ml">Hours</span>
                                            </div>
                                            <div
                                                class="tdSplit"
                                                *ngIf="viewAltShift">
                                                <mat-form-field class="mc-form-field mc-form-field__shift-type--width">
                                                    <mat-select
                                                        formControlName="hoursAlt"
                                                        (selectionChange)="onShiftLengthAltChanged()">
                                                        <mat-option
                                                            *ngFor="let length of hoursValue"
                                                            [value]="length"
                                                            >{{ length }}</mat-option
                                                        >
                                                    </mat-select>
                                                    <mat-error *ngIf="hasError('hoursAlt', 'required')"
                                                        >Alt Shift Length is required</mat-error
                                                    >
                                                </mat-form-field>
                                                <span class="label-text ml">Hours</span>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr *ngIf="editMode">
                                        <td>
                                            <span class="label-text">Shift Time of Day <span>*</span></span>
                                        </td>
                                        <td [ngClass]="{ twoColTd: viewAltShift || isRotatingShift }">
                                            <mat-form-field
                                                class="mc-form-field mc-form-field__shift-type--width tdSplit">
                                                <mat-select
                                                    formControlName="shiftTimeOfDayId"
                                                    (selectionChange)="checkRateUpdateFields('Shift Type')">
                                                    <mat-option
                                                        *ngFor="let option of lookups?.shiftTimes"
                                                        [value]="option.key"
                                                        >{{ option.value }}</mat-option
                                                    >
                                                </mat-select>
                                                <mat-error *ngIf="hasError('shiftTimeOfDayId', 'required')"
                                                    >Shift Time of Day is required</mat-error
                                                >
                                            </mat-form-field>

                                            <mat-form-field
                                                *ngIf="viewAltShift || isRotatingShift"
                                                class="mc-form-field mc-form-field__shift-type--width tdSplit">
                                                <mat-select formControlName="shiftAltTimeOfDayId">
                                                    <mat-option
                                                        *ngFor="let option of lookups?.shiftTimes"
                                                        [value]="option.key"
                                                        >{{ option.value }}</mat-option
                                                    >
                                                </mat-select>
                                                <mat-error *ngIf="hasError('shiftAltTimeOfDayId', 'required')"
                                                    >Alt Shift Time of Day is required</mat-error
                                                >
                                            </mat-form-field>
                                        </td>
                                    </tr>

                                    <tr *ngIf="editMode">
                                        <td>
                                            <span class="label-text">Shift Time</span>
                                            <span class="under-label">Optional</span>
                                        </td>
                                        <td [ngClass]="{ twoColTd: viewAltShift || isRotatingShift }">
                                            <div class="tdSplit">
                                                <table
                                                    class="inner-table"
                                                    aria-label="shift times">
                                                    <tr class="hidden">
                                                        <th scope="col"></th>
                                                        <th scope="col"></th>
                                                        <th scope="col"></th>
                                                    </tr>
                                                    <tr>
                                                        <td><span class="label-text mr">Start</span></td>
                                                        <td>
                                                            <kendo-timepicker
                                                                class="kendo-input-field"
                                                                formControlName="shiftTimeStart"
                                                                (valueChange)="onTimeStartChanged($event)"
                                                                format="HH:mm">
                                                            </kendo-timepicker>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><span class="label-text mr">End</span></td>
                                                        <td>
                                                            <kendo-timepicker
                                                                class="kendo-input-field"
                                                                formControlName="shiftTimeEnd"
                                                                (valueChange)="onTimeEndChanged($event)"
                                                                format="HH:mm">
                                                            </kendo-timepicker>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <div
                                                class="tdSplit"
                                                *ngIf="viewAltShift || isRotatingShift">
                                                <table
                                                    class="inner-table"
                                                    aria-label="alt shift times">
                                                    <tr class="hidden">
                                                        <th scope="col"></th>
                                                        <th scope="col"></th>
                                                        <th scope="col"></th>
                                                    </tr>
                                                    <tr>
                                                        <td><span class="label-text mr">Start</span></td>
                                                        <td>
                                                            <kendo-timepicker
                                                                class="kendo-input-field"
                                                                formControlName="shiftAltTimeStart"
                                                                (valueChange)="onAltTimeStartChanged($event)"
                                                                format="HH:mm">
                                                            </kendo-timepicker>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><span class="label-text mr">End</span></td>
                                                        <td>
                                                            <kendo-timepicker
                                                                class="kendo-input-field"
                                                                formControlName="shiftAltTimeEnd"
                                                                (valueChange)="onAltTimeEndChanged($event)"
                                                                format="HH:mm">
                                                            </kendo-timepicker>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-container>

                                <tr *ngIf="!editMode && offerData?.shiftDetails">
                                    <td><span class="label-text">Shift Details</span></td>
                                    <td>
                                        <span>{{ offerData?.shiftDetails }}</span>
                                    </td>
                                </tr>

                                <tr *ngIf="editMode">
                                    <td><span class="label-text">Shift Details</span></td>
                                    <td>
                                        <textarea
                                            formControlName="shiftDetails"
                                            class="other-notes-textarea"></textarea>
                                    </td>
                                </tr>

                                <tr>
                                    <td colspan="2"></td>
                                </tr>
                                <tr *ngIf="editMode">
                                    <td><span class="label-text">RTO</span></td>
                                    <td>
                                        <mat-checkbox formControlName="hasRequestedTimeOff"></mat-checkbox>
                                    </td>
                                </tr>

                                <tr *ngIf="!editMode && offerData?.hasRequestedTimeOff">
                                    <td
                                        ><span class="label-text">RTO Dates</span>
                                        <nova-rto-alert-icon [enabled]="showRTOAlertOnStartEndDates">
                                        </nova-rto-alert-icon>
                                    </td>
                                    <td>
                                        <div>
                                            <span>{{ offerData?.requestedTimeOffDateText }}</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr *ngIf="!editMode && offerData?.hasRequestedTimeOff">
                                    <td><span class="label-text">RTO Approval</span></td>
                                    <ng-container>
                                        <td>
                                            <span>{{ getRtoApprovalStatus() }}</span>
                                        </td>
                                    </ng-container>
                                </tr>

                                <ng-container *ngIf="editMode && detailsFormGroup.controls.hasRequestedTimeOff.value">
                                    <tr>
                                        <td><span class="label-text">RTO Dates</span></td>
                                        <td>
                                            <div
                                                *ngIf="editMode"
                                                class="rto-container">
                                                <div class="date-input-container">
                                                    <div class="days">
                                                        <span>{{ daysRequested }}</span>
                                                    </div>
                                                    <button
                                                        class="rto-btn"
                                                        mat-icon-button
                                                        [matMenuTriggerFor]="appMenu">
                                                        <mat-icon>event</mat-icon>
                                                    </button>
                                                </div>

                                                <mat-menu
                                                    #appMenu="matMenu"
                                                    class="drop-calendar">
                                                    <div (click)="$event.stopPropagation()">
                                                        <mat-calendar
                                                            #calendar
                                                            class="mat-calendar rto-clanedar"
                                                            [dateClass]="dateClass()"
                                                            [maxDate]="maxDate"
                                                            [minDate]="minDate"
                                                            (selectedChange)="dateChanged($event)"></mat-calendar>
                                                    </div>
                                                </mat-menu>

                                                <a
                                                    class="nova-link rto-clear__btn"
                                                    [class.disabled]="daysSelected.length ? false : true"
                                                    (click)="clearDates()"
                                                    #clearCalendarTrigger="matMenuTrigger"
                                                    [matMenuTriggerFor]="appMenu"
                                                    >Clear</a
                                                >
                                            </div>
                                            <div class="offer-rto-warning">
                                                <nova-rto-warning-message [enabled]="showRTOAlertOnStartEndDates">
                                                </nova-rto-warning-message>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><span class="label-text">RTO Approval</span></td>
                                        <ng-container>
                                            <td>
                                                <mat-form-field
                                                    *ngIf="editMode"
                                                    class="mc-form-field mc-form-field__shift-type--width">
                                                    <mat-select
                                                        formControlName="rtoApprovalStatus"
                                                        data-qa-id="RTOApprovalStatusEdit">
                                                        <mat-option [value]="1">Approved</mat-option>
                                                        <mat-option [value]="2">Pending Approval</mat-option>
                                                        <mat-option [value]="3">Not Approved</mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                        </ng-container>
                                    </tr>
                                </ng-container>
                                <tr>
                                    <td colspan="2"></td>
                                </tr>
                                <tr>
                                    <td><span class="label-text">Facility Rate</span></td>
                                    <td>
                                        <span *ngIf="!editMode">{{ offerData?.facilityRate | currency }}</span>
                                        <span
                                            *ngIf="editMode"
                                            class="label-text mr"
                                            >$</span
                                        >
                                        <mat-form-field *ngIf="editMode">
                                            <input
                                                type="number"
                                                matInput
                                                formControlName="facilityRate"
                                                (keydown)="validateInput($event)"
                                                (keyup)="updateVendorRate()"
                                                (change)="calculateContractDates('facilityRateChanged')" />
                                        </mat-form-field>
                                    </td>
                                </tr>
                                <tr *ngIf="offerData?.recruiterBonus">
                                    <td><span class="label-text">Doughboy</span></td>
                                    <td
                                        ><span
                                            ><nova-recruiter-bonus
                                                [bonus]="offerData?.recruiterBonus"></nova-recruiter-bonus></span
                                    ></td>
                                </tr>
                                <tr
                                    *ngIf="offerData?.offerType === offerTypeEnum.Direct">
                                    <td><span class="label-text">Aya Paid Bonus</span></td>
                                    <td>
                                        <span
                                            *ngIf="!editMode"
                                            data-qa-id="ayaPaidBonus"
                                            >{{ offerData?.ayaPaidBonus ?? 0 | currency }}</span
                                        >
                                        <span
                                            *ngIf="editMode"
                                            class="label-text mr"
                                            >$</span
                                        >
                                        <mat-form-field *ngIf="editMode">
                                            <input
                                                type="number"
                                                matInput
                                                formControlName="ayaPaidBonus"
                                                (keydown)="validateInput($event)"
                                                data-qa-id="ayaPaidBonusInput"
                                                min="0"
                                                max="999999.99" />
                                            <mat-error>Please enter valid bonus amount.</mat-error>
                                        </mat-form-field>
                                    </td>
                                </tr>
                                <tr *ngIf="offerData?.offerType !== offerTypeEnum.Direct">
                                    <td><span class="label-text">Vendor Rate</span></td>
                                    <td class="vendor-row">
                                        <span *ngIf="!editMode">{{ offerData?.vendorRate | currency }}</span>
                                        <span
                                            *ngIf="editMode && rateEnabled"
                                            class="label-text mr"
                                            >$</span
                                        >
                                        <span *ngIf="editMode && !rateEnabled">{{
                                            detailsFormGroup?.controls['vendorRate']?.value | currency
                                        }}</span>
                                        <span
                                            *ngIf="editMode && !rateEnabled"
                                            (click)="rateEdit()"
                                            class="material-icons pencil"
                                            >edit</span
                                        >
                                        <mat-form-field *ngIf="editMode && rateEnabled">
                                            <input
                                                type="number"
                                                matInput
                                                formControlName="vendorRate"
                                                (keydown)="validateInput($event)" />
                                        </mat-form-field>
                                    </td>
                                </tr>
                                <tr *ngIf="offerData?.otherDetails || editMode">
                                    <td colspan="2"></td>
                                </tr>
                                <tr *ngIf="offerData?.otherDetails || editMode">
                                    <td><span class="label-text">Other Details</span></td>
                                    <td>
                                        <ng-container *ngIf="editMode; else otherDetailsNonEdit">
                                            <div class="flex-col flex-1">
                                                <mat-form-field>
                                                    <textarea
                                                        matInput
                                                        formControlName="otherDetails"
                                                        data-qa-id="otherDetails-textarea"
                                                        class="other-notes-textarea"
                                                        maxlength="1500"></textarea>
                                                    <mat-hint align="end">{{ detailsFormGroup.controls.otherDetails.value?.length ?? 0 }}/1500 characters</mat-hint>
                                                </mat-form-field>
                                            </div>
                                        </ng-container>
                                        <ng-template #otherDetailsNonEdit>
                                            <span [innerHTML]="offerData?.otherDetails"></span>
                                        </ng-template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </form>
                </mat-card-content>
            </mat-card>
        }

        <div class="offer-details-sidebar">
            @if (offerData && isOfferOptimizationsEnabled() && offerData.id) {
                <nova-points-of-contact class="points-of-contact" [offerId]="offerData.id"> </nova-points-of-contact>
            }

            <div class="attachments-notes-container">
                <mat-card class="attachments" [ngClass]="isOfferOptimizationsEnabled() ? 'card-border' : ''">
                    <mat-card-content>
                        <nova-shared-offer-attachments
                            [editMode]="editMode"
                            [canModify]="canModify"
                            [attachments]="attachmentData"
                            [offerType]="offerData?.offerType"
                            [headingTitle]="attachmentsHeadingTitle"
                            [headingTitleSubtext]="attachmentsHeadingTitleSubtext"
                            (attachmentUpload)="attachmentToUpload($event)"
                            (attachmentUpdate)="attachmentToUpdate($event)"
                            (attachmentDelete)="attachmentToDelete($event)"
                            (getAttachmentFile)="attachmentToGet($event)">
                        </nova-shared-offer-attachments>
                    </mat-card-content>
                </mat-card>

            <mat-card class="notes" [ngClass]="isOfferOptimizationsEnabled() ? 'card-border' : ''">
                <mat-card-content>
                    <nova-shared-notes
                        [agencyNotes]="offerNotes"
                        [offerType]="offerData?.offerType"
                        [isVMS]="offerData?.isVMS"
                        [vmsType]="offerData?.vmsType"
                        [userType]="userType"
                        [headingTitle]="notesHeadingTitle"
                        [headingTitleSubtext]="notesHeadingTitleSubtext"
                        (noteAdded)="addNoteText($event)"
                        (noteWithCategoryAdded)="addNoteWithNoteTextAndCategory($event)">
                        <div
                            *ngIf="canModify"
                            noteInput
                            class="note-input">
                            <textarea
                                class="note-textarea"
                                data-qa-id="an_shared_notes_textarea"
                                [(ngModel)]="enteredNoteText"></textarea>
                            <ng-container *ngIf="!shouldDisplayNoteCategoryButtons">
                                <button
                                    mat-flat-button
                                    color="primary"
                                    [disabled]="!enteredNoteText"
                                    (click)="addNote()"
                                    data-qa-id="an_shared_notes_send_note">
                                    Send Note
                                </button>
                            </ng-container>
                            <ng-container *ngIf="shouldDisplayNoteCategoryButtons">
                                <button
                                    mat-flat-button
                                    color="primary"
                                    [disabled]="!enteredNoteText"
                                    (click)="addNoteWithCategory(offerNotesCategory.ClientFacing)"
                                    data-qa-id="an_shared_notes_send_to_client">
                                    Send Note to Client
                                </button>
                                <button
                                    mat-flat-button
                                    class="right-button-margin"
                                    color="primary"
                                    [disabled]="!enteredNoteText"
                                    (click)="addNoteWithCategory(offerNotesCategory.NonClientFacing)"
                                    data-qa-id="an_shared_notes_send_to_recruiter">
                                    Send Note to Recruiter
                                </button>
                            </ng-container>
                        </div>
                    </nova-shared-notes>
                </mat-card-content>
            </mat-card>
            </div>
        </div>
    </div>
</div>
